import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 33622 47714"
    {...props}
  >
    <path
      d="M8904 21732c1241-1494 2586-2649 4021-3474v6057c-857 655-1567 1501-2146 2538-734 1338-1107 2906-1107 4704 0 2896 745 5308 2248 7228 318 408 653 773 1005 1095v7611c-1777-432-3399-1142-4865-2127-2610-1754-4606-4354-5987-7786C691 34146 0 29935 0 24978c0-4046 417-7665 1250-10856 833-3192 2040-5835 3597-7929 1568-2105 3465-3684 5692-4759 759-363 1555-665 2386-905v7586c-462 436-882 925-1257 1467-1569 2270-2489 6327-2764 12150zm11792-5067c1541 130 2991 494 4339 1086 1722 757 3235 1843 4529 3246 1295 1404 2293 3060 2994 4957 713 1908 1064 3904 1064 5976 0 3027-691 5769-2072 8225-1382 2468-3302 4386-5780 5768-1557 872-3251 1470-5074 1791v-6778c836-441 1589-1077 2256-1911 1415-1765 2116-4079 2116-6952 0-1941-329-3619-997-5022-659-1404-1569-2478-2731-3214-211-132-425-254-644-363v-6809zm0-16665c1715 234 3278 713 4690 1434 2095 1075 3663 2401 4727 3980 1053 1579 1590 3104 1590 4551 0 877-340 1678-998 2391s-1502 1075-2534 1075c-899 0-1732-285-2500-856-767-559-1338-1349-1699-2357-494-1283-1272-2314-2347-3093-295-216-605-402-929-559V0z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
